"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("ajv/dist/compile/codegen");

var _util_1 = require("./_util");

var regexpMetaSchema = {
  type: "object",
  properties: {
    pattern: {
      type: "string"
    },
    flags: {
      type: "string",
      nullable: true
    }
  },
  required: ["pattern"],
  additionalProperties: false
};
var metaRegexp = /^\/(.*)\/([gimuy]*)$/;

function getDef() {
  return {
    keyword: "regexp",
    type: "string",
    schemaType: ["string", "object"],
    code: function code(cxt) {
      var data = cxt.data,
          schema = cxt.schema;
      var regx = getRegExp(schema);
      cxt.pass((0, codegen_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ".test(", ")"])), regx, data));

      function getRegExp(sch) {
        if (typeof sch == "object") return (0, _util_1.usePattern)(cxt, sch.pattern, sch.flags);
        var rx = metaRegexp.exec(sch);
        if (rx) return (0, _util_1.usePattern)(cxt, rx[1], rx[2]);
        throw new Error("cannot parse string into RegExp");
      }
    },
    metaSchema: {
      anyOf: [{
        type: "string"
      }, regexpMetaSchema]
    }
  };
}

exports.default = getDef;
module.exports = getDef;